import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { Box, Text } from "pcln-design-system";
import { MyTripsList } from "./MyTripsList.js";
import { myTripContextData } from "./myTripDataContext.js";
const TripsHeader = ({ title, isRealTime })=>/*#__PURE__*/ jsx(Text, {
        fontWeight: "bold",
        my: 2,
        color: isRealTime ? 'text.lightest' : 'text.dark',
        children: title
    });
const ListOfDifferentTrips = ()=>{
    const { currentTrips, upcomingTrips, pastTrips, canceledTrips } = useContext(myTripContextData);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            currentTrips?.length > 0 && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(TripsHeader, {
                        title: "Your current trip"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ jsx(MyTripsList, {
                            trips: currentTrips,
                            tripCategory: "currentTrips"
                        })
                    })
                ]
            }),
            upcomingTrips?.length > 0 && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(TripsHeader, {
                        title: "Upcoming trip(s)"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ jsx(MyTripsList, {
                            trips: upcomingTrips,
                            tripCategory: "upcomingTrips"
                        })
                    })
                ]
            }),
            pastTrips?.length > 0 && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(TripsHeader, {
                        title: "Past trip(s)"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ jsx(MyTripsList, {
                            trips: pastTrips,
                            tripCategory: "pastTrips"
                        })
                    })
                ]
            }),
            canceledTrips?.length > 0 && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(TripsHeader, {
                        title: "Cancelled trip(s)"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ jsx(MyTripsList, {
                            trips: canceledTrips,
                            tripCategory: "canceledTrips"
                        })
                    })
                ]
            })
        ]
    });
};
export { ListOfDifferentTrips };
